export default function(){

	$('.js-range-slider').each(function(){
		rangeSlider($(this));

	});



	function rangeSlider($range_slider) {
		const initSlider = function() {
			var $min = getMin();
			var $max = getMax();
			var $slider = getSlider();
			var min = getMinBound();
			var max = getMaxBound();
			var current_min = handleNumber($min.val(), min, [min, max]);
			var current_max = handleNumber($max.val(), max, [current_min, max]);

			$slider.slider({
				range: true,
				min: min,
				max: max,
				values: [current_min, current_max],
				slide: function (e, ui) {
					if (ui.values[0] === min) {
						$min.val('');
					} else {
						$min.val(ui.values[0]);
					}

					if (ui.values[1] === max) {
						$max.val('');
					} else {
						$max.val(ui.values[1]);
					}
				},
				stop: function (e, ui) {
					if (ui.handleIndex === 0) {
						$min.trigger('change');
					} else if (ui.handleIndex === 1) {
						$max.trigger('change');
					}
				}
			});
		};
		const initEventListeners = function() {
			var $min = getMin();
			var $max = getMax();
			var $slider = getSlider();
			var min = getMinBound();
			var max = getMaxBound();

			$min.on('input', function () {
				var values = $slider.slider('values');

				values[0] = handleNumber($(this).val(), min, [min, values[1]]);
				$slider.slider('values', values);
			});

			$min.on('blur change', function () {
				var values = $slider.slider('values');

				var value = handleNumber($(this).val(), min, [min, values[1]]);

				if (value === min) {
					$min.val('');
				} else {
					$min.val(value);
				}

				values[0] = value;
				$slider.slider('values', values);
			});

			$max.on('input', function () {
				var values = $slider.slider('values');

				values[1] = handleNumber($(this).val(), max, [values[0], max]);
				$slider.slider('values', values);
			});

			$max.on('blur change', function () {
				var values = $slider.slider('values');

				var value = handleNumber($(this).val(), max, [values[0], max]);

				if (value === max) {
					$max.val('');
				} else {
					$max.val(value);
				}

				values[1] = value;
				$slider.slider('values', values);
			});
		};
		const getSlider = function() {
			return $range_slider.find('.js-range-slider__slider');
		};
		const getMin = function() {
			return $range_slider.find('.js-range-slider__input_min');
		};
		const getMax = function() {
			return $range_slider.find('.js-range-slider__input_max');
		};
		const getMinBound = function() {
			return +$range_slider.data('min');
		};
		const getMaxBound = function() {
			return +$range_slider.data('max');
		};
		const handleNumber = function(number, def, range) {
			if (number === '') {
				number = NaN;
			}

			number = +number;

			if (isNaN(number)) {
				return def;
			}

			number = Math.max(range[0], Math.min(range[1], number));

			return number;
		};

		initSlider();
		initEventListeners();
	}
}
